<template>
	<ul class="list-none">
		<FormPasswordValidationListItem
			v-for="item in validationListItems"
			:key="item.text"
			:text="item.text"
			:is-valid="item.isValid"
		/>
	</ul>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	useScope: 'global'
})

const props = defineProps({
	password: {
		type: String,
		default: ''
	}
})

const { password } = toRefs(props)

const validationListItems = computed(() => {
	return [
		{
			text: t('password.twelve-characters'),
			isValid: password.value?.length >= 12
		},
		{
			text: t('password.uppercase'),
			isValid: /[A-Z]/.test(password.value)
		},
		{
			text: t('password.lowercase'),
			isValid: /[a-z]/.test(password.value)
		},
		{
			text: t('password.number'),
			isValid: /\d/.test(password.value)
		},
		{
			text: t('password.special-character'),
			isValid: /[!@#$%^&*(),.?":{}|<>]/.test(password.value)
		}
	]
})
</script>
